import React from "react";
import TextInput from "../common/inputs/textInput";
// import NotificationManager from './common/notifications/NotificationManager';
import Loading from "../common/loading";
import Logo from "../../synaccess_white.svg";
import { Link } from "react-router-dom";
import "./login.css";

export default class Login extends React.Component {
  state = {
    username: "",
    password: "",
    usernameError: "",
    passwordError: "",
    loading: false,
    stayLoggedIn: true,
    logo: Logo,
    logoWidth: "170px",
    loginBackgroundClass: "",
  };
  submit() {
    // console.log("Submitting")
    this.setState({
      usernameError: "",
      passwordError: "",
      loading: true,
    });

    if (!this.state.username && !this.state.password) {
      this.setState({
        usernameError: "Missing Username",
        passwordError: "Missing Password",
        loading: false,
      });
    } else if (!this.state.username) {
      this.setState({
        usernameError: "Missing Username",
        loading: false,
      });
    } else if (!this.state.password) {
      this.setState({
        passwordError: "Missing Password",
        loading: false,
      });
    } else {
      this.props.fetchLogin(
        this.state.username,
        this.state.password,
        () => {
          this.setState({
            loading: false,
          });
        },
        this.state.stayLoggedIn
      );
    }
  }
  // forgottenPassword = () => {
  //   alert("TODO");
  // };

  render() {
    const {
      username,
      password,
      usernameError,
      passwordError,
      loading,
      stayLoggedIn,
    } = this.state;
    return (
      <div
        className={`background-gradient ${this.state.loginBackgroundClass} login-page`}
      >
        <div className="login-page__container">
          <div className="login-card">
            <div className="login-card__logo">
              <img alt="logo" src={this.state.logo} width={this.state.logoWidth} />
            </div>
            <div className="login-card__surface">
              <h1 className="login-card__header">Sign in to your account</h1>
              <form
                className="login-card__form"
                onSubmit={(e) => {
                  e.preventDefault();
                  this.submit();
                }}
              >
                <TextInput
                  label="Email"
                  placeholder="Email"
                  value={username}
                  error={usernameError}
                  callback={(data) => this.setState({ username: data })}
                  tabIndex="1"
                />
                <div className="login-card__input-row">
                  <TextInput
                    label="Password"
                    value={password}
                    error={passwordError}
                    type="password"
                    placeholder="Password"
                    callback={(data) => this.setState({ password: data })}
                    inputContainerStyle={{
                      width: "100%",
                    }}
                    tabIndex="2"
                    labelMate={
                      <div className="login-card__link">
                        <Link to="/reset" tabIndex="-1">
                          Forgot your password?
                        </Link>
                      </div>
                    }
                  />
                </div>
                {this.props.errMessage && (
                  <div className="login-card__error">{this.props.errMessage}</div>
                )}
                <button
                  type="button"
                  className="login-card__stay-signed-in"
                  role="switch"
                  aria-checked={stayLoggedIn}
                  onClick={() => this.setState({ stayLoggedIn: !stayLoggedIn })}
                >
                  <span
                    className={`login-card__switch ${
                      stayLoggedIn ? "login-card__switch--on" : ""
                    }`}
                    aria-hidden="true"
                  >
                    <span className="login-card__switch-thumb" />
                  </span>
                  <span className="login-card__stay-signed-in-label">
                    Stay signed in for a week
                  </span>
                </button>
                <div className="login-card__actions">
                  <button className="button login-card__submit" type="submit">
                    {loading ? <Loading /> : "Continue"}
                  </button>
                </div>
              </form>
              <div className="login-card__saml">
                <div className="login-card__saml-button">
                  <button
                    className="button login-card__saml-trigger"
                    onClick={() => {
                      this.props.history.push("/saml-login");
                    }}
                  >
                    Sign in with SSO
                  </button>
                </div>
              </div>
            </div>
            <div className="login-card__footer">
              Don't have an account?{" "}
              <Link className="login-card__footer-link" to="/register">
                Sign up
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
